// ============================================================================
// This file is MCOR 2026 PROJECT SPECIFIC
// ============================================================================

// Registration Categories
const initCategories = () => {
  const countrySelect = document.getElementById("user_country");
  const memberTypeSelect = document.getElementById("user_member_type_id");

  if (!countrySelect || !memberTypeSelect) return;

  // Skip initialization if member type field is disabled (editing mode)
  if (memberTypeSelect.disabled) return;

  // Categories and their nationality rules come from MemberType#country_rule and
  // member_type_countries, so renaming or adding a category in the admin needs
  // no matching change here.
  const rules = JSON.parse(memberTypeSelect.dataset.memberTypeRules || "[]");

  const categoriesFor = (countryCode) =>
    rules.filter((entry) => {
      switch (entry.rule) {
        case "all_countries":
          return true;
        case "specific_countries":
          return entry.countries.includes(countryCode);
        case "exclude_countries":
          return !entry.countries.includes(countryCode);
        default:
          return false;
      }
    });

  function updateMemberTypeOptions() {
    const countryCode = (countrySelect.value || "").toUpperCase();
    const previousId = memberTypeSelect.value;

    // Clear existing options
    memberTypeSelect.innerHTML =
      '<option value="">- Select Category -</option>';

    // No nationality picked yet, so no category can be resolved.
    const categories = countryCode ? categoriesFor(countryCode) : [];

    // Add new options
    categories.forEach(function (category) {
      const option = document.createElement("option");
      option.value = category.id;
      option.textContent = category.name;
      memberTypeSelect.appendChild(option);
    });

    // Keep the existing choice when it is still valid, so re-rendering after a
    // failed submit does not silently discard what the user picked.
    if (
      previousId &&
      categories.some((category) => String(category.id) === previousId)
    ) {
      memberTypeSelect.value = previousId;
    }

    // Enable/disable member type select
    memberTypeSelect.disabled = categories.length === 0;
  }

  countrySelect.addEventListener("change", updateMemberTypeOptions);

  // Initialize on page load
  updateMemberTypeOptions();
};

// Make supporting upload required for "Malaysian Radiology Trainees, Candidate Member, Medical Officer" member type only

const initSupportingRequired = () => {
  const memberTypeSelect = document.getElementById("user_member_type_id");
  const supportingInput = document.getElementById("user_supporting_upload");
  const isEditPage = !!document.getElementById("current-supporting");
  if (!memberTypeSelect || !supportingInput) return;

  const updateSupportingRequired = () => {
    const selectedMemberType =
      memberTypeSelect.options[memberTypeSelect.selectedIndex]?.text;
    supportingInput.required = isEditPage
      ? false
      : selectedMemberType == "Malaysian Radiology Trainees, Candidate Member, Medical Officer";
  };

  memberTypeSelect.addEventListener("change", updateSupportingRequired);
  if (memberTypeSelect.value) updateSupportingRequired();
};

const initPassportUploadField = () => {
  const countrySelect = document.getElementById("user_country");
  const passportUploadWrapper = document.getElementById("passport-upload-wrapper");
  const passportUploadInput = document.getElementById("user_passport_upload");

  if (!countrySelect || !passportUploadWrapper || !passportUploadInput) return;

  const updatePassportUploadField = () => {
    const countryCode = (countrySelect.value || "").toUpperCase();
    const requiresPassportUpload = countryCode !== "" && countryCode !== "MY";
    passportUploadWrapper.classList.toggle("hidden", !requiresPassportUpload);
    passportUploadInput.required = requiresPassportUpload;
  };

  countrySelect.addEventListener("change", updatePassportUploadField);
  updatePassportUploadField();
};

// Initialize all custom functionality
const initMcor2026Registration = () => {
  initCategories();
  initSupportingRequired();
  initPassportUploadField();
};

export default initMcor2026Registration;
